import { motion } from "framer-motion";
import { tools } from "@/data/toolsData";
import { ToolCard } from "./tools/ToolCard";
import { ResponsiveGrid } from "./shared/ResponsiveGrid";

export const ToolsSection = () => {
  return (
    <section className="py-16 px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl font-serif mb-4">
            Twin Flame Tools & Assessments
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Explore our collection of spiritual tools designed to help you navigate your twin flame journey
          </p>
        </motion.div>

        <ResponsiveGrid>
          {tools.map((tool, index) => (
            <ToolCard key={tool.title} {...tool} index={index} />
          ))}
        </ResponsiveGrid>
      </div>
    </section>
  );
};